import React, { Fragment, useState } from 'react'
import { SelectChangeEvent } from '@mui/material/Select'

import {
  WorkOrderReportElement,
  WorkOrderDashboardFilters
} from '../../components/WorkOrder/'

import { Loading, PageTitle } from '../../components/UI'

import { TypeDate } from '../../enums/eTypeDate'

import { WorkOrderReportFilters } from '../../interfaces/WorkOrder/WorkOrderReportDashboard'

import { DateTime, Interval } from 'luxon'

import useWorkOrderDashboard from './useWorkOrderDashboard'

import { Box, Button } from '@mui/material'

interface WorkOrderDashboardPageProps { }

export const WorkOrderDashboardPage: React.FC<
  WorkOrderDashboardPageProps
> = () => {
  const { error, loading, getWorkOrderDashboard, workOrderDashboardData } =
    useWorkOrderDashboard()

  const [values, setValues] = useState<WorkOrderReportFilters>({
    type: TypeDate.CourierDeliveryDateTime,
    initialDate: DateTime.local().startOf('day').toUTC(),
    finalDate: DateTime.local().endOf('day').toUTC(),
    isValid: true,
    loading: false,
    warehouseId: '0'
  })

  const handleChangeWarehouse = (event: SelectChangeEvent<string>) => {
    setValues({
      ...values,
      warehouseId: event.target.value
    })
  }

  const handleChangeDateTime = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const selectedDateUTC = DateTime.fromISO(e.target.value).toUTC()
    setValues({
      ...values,
      [e.target.name]: selectedDateUTC
    })
  }

  // Validar rango de fechas
  React.useEffect(() => {
    setValues((prevState) => ({
      ...prevState,
      isValid: Interval.fromDateTimes(
        prevState.initialDate,
        prevState.finalDate
      ).isValid
    }))
  }, [values.initialDate, values.finalDate])

  const handleSetDateType = (dateType: TypeDate) =>
    setValues({ ...values, type: dateType })

  if (loading) return <Loading />

  return (
    <Fragment>
      <PageTitle title='Avances de OT de Salida' />

      <WorkOrderDashboardFilters
        handleSearch={handleChangeDateTime}
        handleChangeDateType={handleSetDateType}
        values={values}
        handleChangeWarehouse={handleChangeWarehouse}
      />

      <Box
        display='flex'
        flexDirection='row'
        justifyContent='flex-end'
        alignItems='center'
        padding='15px'
      >
        <Button
          disabled={!values.isValid}
          color={'primary'}
          variant='contained'
          onClick={() => getWorkOrderDashboard(values)}
        >
          Buscar
        </Button>
      </Box>

      <WorkOrderReportElement
        workOrderDashboardData={workOrderDashboardData}
        values={values}
        error={error}
      />
    </Fragment>
  )
}
